(() => {
  const BAR_SELECTOR = '[data-zalvaro-mobile-atc]';

  const initialiseBar = (bar) => {
    if (bar.dataset.zalvaroMobileAtcReady === 'true') return;

    const productInfo = bar.closest("product-info[id^='MainProduct-']");
    const proxyButton = bar.querySelector('[data-zalvaro-mobile-atc-button]');
    const proxyLabel = bar.querySelector('[data-zalvaro-mobile-atc-label]');
    const sectionId = bar.dataset.sectionId;
    const sourceButton = productInfo?.querySelector(`#ProductSubmitButton-${CSS.escape(sectionId)}`);

    if (!productInfo || !proxyButton || !proxyLabel || !sourceButton) return;

    bar.dataset.zalvaroMobileAtcReady = 'true';

    const syncState = () => {
      const sourceLabel = sourceButton.querySelector('span');
      const isLoading = sourceButton.classList.contains('loading');
      const needsSize = sourceButton.dataset.sizeRequiredPending === 'true';
      const isDisabled = !needsSize && (sourceButton.disabled || sourceButton.getAttribute('aria-disabled') === 'true');

      if (sourceLabel?.textContent.trim()) {
        proxyLabel.textContent = sourceLabel.textContent.trim();
      }

      proxyButton.disabled = isDisabled;
      proxyButton.setAttribute('aria-disabled', String(isDisabled));
      proxyButton.classList.toggle('is-loading', isLoading);
      proxyButton.toggleAttribute('aria-busy', isLoading);

      if (sourceButton.hasAttribute('aria-haspopup')) {
        proxyButton.setAttribute('aria-haspopup', sourceButton.getAttribute('aria-haspopup'));
      }
    };

    proxyButton.addEventListener('click', () => {
      syncState();
      if (proxyButton.disabled) return;
      sourceButton.click();
    });

    new MutationObserver(syncState).observe(sourceButton, {
      attributes: true,
      attributeFilter: ['aria-disabled', 'class', 'data-size-required-pending', 'disabled'],
      childList: true,
      characterData: true,
      subtree: true,
    });

    syncState();
    bar.hidden = false;
    document.body.classList.add('zalvaro-mobile-atc-active');
  };

  const initialiseAll = (root = document) => {
    if (root.matches?.(BAR_SELECTOR)) initialiseBar(root);
    root.querySelectorAll?.(BAR_SELECTOR).forEach(initialiseBar);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialiseAll(), { once: true });
  } else {
    initialiseAll();
  }

  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) initialiseAll(node);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
})();
